import { render, staticRenderFns } from "./page-brands-id-type-1.vue?vue&type=template&id=74f49b6d&"
import script from "./page-brands-id-type-1.vue?vue&type=script&lang=ts&"
export * from "./page-brands-id-type-1.vue?vue&type=script&lang=ts&"
import style0 from "./page-brands-id-type-1.vue?vue&type=style&index=0&lang=scss&module=styleGrid&"
import style1 from "./page-brands-id-type-1.vue?vue&type=style&index=1&lang=scss&module=styleMobileGrid&"
import style2 from "./page-brands-id-type-1.vue?vue&type=style&index=2&lang=scss&module=styleSpacer&"
import style3 from "./page-brands-id-type-1.vue?vue&type=style&index=3&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleGrid"] = (style0.locals || style0)
this["styleMobileGrid"] = (style1.locals || style1)
this["styleSpacer"] = (style2.locals || style2)
this["$style"] = (style3.locals || style3)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports